/**
 * App metadata: currencies, categories, wedding templates + applyTemplate.
 * Kept together because they're all static/global reference data.
 */
import { useCallback, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useMetadata() {
  const [currencies, setCurrencies] = useState({ currencies: [], rates: {} });
  const [categories, setCategories] = useState([]);
  const [templates, setTemplates] = useState([]);

  const fetchCategories = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/categories`, { withCredentials: true });
      setCategories(data.categories);
    } catch (err) { console.error('Error fetching categories:', err); }
  }, []);

  const fetchCurrencies = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/currencies`, { withCredentials: true });
      setCurrencies(data);
    } catch (err) { console.error('Error fetching currencies:', err); }
  }, []);

  const fetchTemplates = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/templates`, { withCredentials: true });
      setTemplates(data.templates);
    } catch (err) { console.error('Error fetching templates:', err); }
  }, []);

  /**
   * Apply a template to a wedding. Caller is responsible for re-fetching
   * the events/checklist/dashboard afterwards — the context wires that up.
   */
  const applyTemplate = useCallback(async (weddingId, templateId) => {
    const { data } = await axios.post(`${API}/templates/apply`, {
      wedding_id: weddingId,
      template_id: templateId,
    }, { withCredentials: true });
    return data;
  }, []);

  return {
    currencies, categories, templates,
    fetchCategories, fetchCurrencies, fetchTemplates, applyTemplate,
  };
}
